module.exports = __webpack_public_path__ + "img/13.0e1247e2.png";